import api from "@/api";

const state = {
    names: {},
    properties: {},
};

const getters = {
    names(state) {
        return state.names;
    },
    properties(state) {
        return state.properties;
    },
};

const actions = {
    getNames({ commit }) {
        return api.get(`/api/events/names`).then(res => {
            const names = res?.data?.names ?? {};

            commit("updateNames", names);
        });
    },
    getProperties({ commit }) {
        return api.get(`/api/events/properties`).then(res => {
            const properties = res?.data?.properties ?? {};

            commit("updateProperties", properties);
        });
    },

    track: (_, { payload: { name, properties } }) => {
        return api.post(`/api/events`, { name, properties });
    },
};

const mutations = {
    updateNames(state, names) {
        state.names = names;
    },
    updateProperties(state, properties) {
        state.properties = properties;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
